export default __webpack_public_path__ + "static/media/idolsNFT.573829a5.svg";